export enum LogLevel {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR'
}

export enum LogCategory {
    BALL = 'BALL',
    PLAYER = 'PLAYER',
    COURT = 'COURT',
    GENERAL = 'GENERAL',
    NETWORK = 'NETWORK',
}

export class Debug {
    private static currentLogLevel: LogLevel = LogLevel.INFO;

    private static formatMessage(message: any, level: LogLevel, category: LogCategory): string {
        const timestamp = new Date().toISOString();
        return `[${timestamp}] [${level}] [${category}] ${message}`;
    }

    private static shouldLog(messageLevel: LogLevel): boolean {
        // If current level is INFO, log everything
        if (this.currentLogLevel === LogLevel.INFO) return true;
        
        // If current level is WARNING, log only warnings and errors
        if (this.currentLogLevel === LogLevel.WARNING) {
            return messageLevel === LogLevel.WARNING || messageLevel === LogLevel.ERROR;
        }
        
        // If current level is ERROR, log only errors
        if (this.currentLogLevel === LogLevel.ERROR) {
            return messageLevel === LogLevel.ERROR;
        }

        return false;
    }

    static setLogLevel(level: LogLevel): void {
        this.currentLogLevel = level;
        this.info(`Log level set to ${level}`, LogCategory.GENERAL);
    }

    static getLogLevel(): LogLevel {
        return this.currentLogLevel;
    }

    static log(message: any, level: LogLevel = LogLevel.INFO, category: LogCategory = LogCategory.GENERAL): void {
        if (!this.shouldLog(level)) return;

        const formattedMessage = this.formatMessage(message, level, category);
        
        switch (level) {
            case LogLevel.ERROR:
                console.error(formattedMessage);
                break;
            case LogLevel.WARNING:
                console.warn(formattedMessage);
                break;
            default:
                console.log(formattedMessage);
        }
    }

    static info(message: any, category: LogCategory = LogCategory.GENERAL): void {
        this.log(message, LogLevel.INFO, category);
    }

    static warn(message: any, category: LogCategory = LogCategory.GENERAL): void {
        this.log(message, LogLevel.WARNING, category);
    }

    static error(message: any, category: LogCategory = LogCategory.GENERAL): void {
        this.log(message, LogLevel.ERROR, category);
    }
} 